import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=2b88258e"
import script from "./AgentList.vue?vue&type=script&lang=js"
export * from "./AgentList.vue?vue&type=script&lang=js"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=2b88258e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports